import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const MergeChecksLoadable = Loadable<any, never>({
  loading: LoadingPage,

  loader: () => import('./merge-checks-repository-settings-page'),
});
